export default function WhatIsSection() {
  return (
    <section id="programa" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-purple-100 text-purple-700 px-6 py-2 rounded-full text-sm font-semibold uppercase tracking-wider mb-6">
            Programa de Liderança Feminina
          </div>
          <h2 className="font-display text-5xl lg:text-6xl font-bold text-purple-900 mb-8 leading-tight">
            <strong>Primeiro eu me lidero.</strong><br />
            Depois lidero a minha vida.<br />
            Então lidero pessoas.
          </h2>
          <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            O <strong>Eu Lidero</strong> é um programa online de <strong>liderança feminina</strong> inspirado na imersão internacional Salto Alto. 
            Desenvolvido para mulheres que querem transformar sua carreira, alcançar resultados extraordinários e 
            construir um legado de impacto através da <strong>autoliderança</strong>, propósito e influência.
          </p>
        </div>
      </div>
    </section>
  );
}
